import { render } from "./TaskRecord.vue?vue&type=template&id=02e94f54&scoped=true&ts=true"
import script from "./TaskRecord.vue?vue&type=script&lang=ts"
export * from "./TaskRecord.vue?vue&type=script&lang=ts"

import "./TaskRecord.vue?vue&type=style&index=0&id=02e94f54&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e94f54"]])

export default __exports__